const isUnsupportedControlCharacter = (char: string): boolean => {
  const codePoint = char.codePointAt(0);
  if (codePoint === undefined) {
    return false;
  }

  return (
    (codePoint >= 0x00 && codePoint <= 0x08) ||
    codePoint === 0x0b ||
    codePoint === 0x0c ||
    (codePoint >= 0x0e && codePoint <= 0x1f) ||
    codePoint === 0x7f
  );
};

const stripControlCharacters = (value: string): string =>
  Array.from(value)
    .filter(char => !isUnsupportedControlCharacter(char))
    .join('');

export const sanitizeTextInput = (value: string): string =>
  stripControlCharacters(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');

const sanitizeUnknownPayload = (payload: unknown): unknown => {
  if (typeof payload === 'string') {
    return sanitizeTextInput(payload);
  }

  if (Array.isArray(payload)) {
    return payload.map((item) => sanitizeUnknownPayload(item));
  }

  if (payload && typeof payload === 'object') {
    const input = payload as Record<string, unknown>;
    const sanitizedObject: Record<string, unknown> = {};

    Object.entries(input).forEach(([key, value]) => {
      sanitizedObject[key] = sanitizeUnknownPayload(value);
    });

    return sanitizedObject;
  }

  return payload;
};

export const sanitizePayloadDeep = <T>(payload: T): T =>
  sanitizeUnknownPayload(payload) as T;
